import { ListBases$Params } from '../../../api/scheduler/functions';
import { BaseDto } from '../../../api/scheduler/models/base-dto';
import { BaseListQuery, BaseSortKey } from '../models';

/** Whitelisted `sort` field for each column. Paths such as `location.name` are rejected. */
const SERVER_SORT_FIELD: Record<BaseSortKey, string> = {
  name: 'name',
  status: 'status',
  lead: 'baseLead',
  location: 'location',
};

export interface BaseListPage {
  bases: BaseDto[];
  totalElements: number;
  totalPages: number;
}

/** Newest Bases first. The API default is name,asc when `sort` is omitted, so this is sent explicitly. */
export const DEFAULT_BASE_SORT = 'createdAt,desc';

/** Value for the API `sort` parameter, e.g. `createdAt,desc`. */
export function toServerSort(query: BaseListQuery): string {
  if (!query.sortKey) return DEFAULT_BASE_SORT;
  return `${SERVER_SORT_FIELD[query.sortKey]},${query.sortDir}`;
}

/**
 * One page of the Bases list. Status and shifts are filtered by the API, so the request uses
 * the page size on screen.
 */
export function toListBasesParams(query: BaseListQuery): ListBases$Params {
  const { status, shifts } = query.filters;
  return {
    page: query.page,
    size: query.size,
    search: query.search.trim() || undefined,
    sort: toServerSort(query),
    status: status === 'All' ? undefined : status === 'Active' ? 'ACTIVE' : 'INACTIVE',
    shifts: shifts.length ? shifts.map(Number) : undefined,
  };
}
